module.exports = __webpack_public_path__ + "img/AWF_Logo.8cb5ba8d.png";